import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { serialize } from "next-mdx-remote/serialize";

import getTranslationByPath from "../services/getTranslationByPath.mjs";
import Container from "../components/Common/Container";
import Hero from "../components/Partnerships/Hero";
import PartnershipReasons from "../components/Partnerships/PartnershipReasons/PartnershipReasons";
import Form from "../components/Partnerships/Form";
import MetaTags from "../components/Common/MetaTags";
import Testimonial from "../components/Targets/Testimonial";

import testimonialImage from "../public/static/images/partnerships/marianne-pereira.jpeg";
import CloudinaryImage from "../components/Common/CloudinaryImage/CloudinaryImage.js";

export default function Partnerships({ heroSubSlogan }) {
  const theme = useTheme();
  const { t } = useTranslation(["partnerships", "common"]);

  return (
    <>
      <MetaTags scope="partnerships" />
      <Box bgcolor={theme.palette.alternate.main}>
        <Container>
          <Hero
            pageTitle={t("navbar.partnerships", { ns: "common" })}
            subSlogan={heroSubSlogan}
          />
        </Container>
      </Box>
      <Box bgcolor={theme.palette.alternate.dark}>
        <Container position="relative" zIndex={2}>
          <Testimonial
            header={t("testimonial.header")}
            content={t("testimonial.content")}
            fullName={t("testimonial.full_name")}
            jobTitle={t("testimonial.job_title")}
            image={
              <CloudinaryImage
                src={testimonialImage}
                alt={`${t("testimonial.full_name")} ${t(
                  "testimonial.job_title"
                )}`}
                width={50}
                height={50}
                layout="fixed"
                priority
              />
            }
          />
        </Container>
      </Box>
      <PartnershipReasons />
      <Form />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const { content } = getTranslationByPath("partnerships", locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "partnerships"])),
      heroSubSlogan: await serialize(content.hero.subSlogan),
    },
  };
}
